import { render, staticRenderFns } from "./PaymentdetailKurir.vue?vue&type=template&id=4cd44d72"
import script from "./PaymentdetailKurir.vue?vue&type=script&lang=js"
export * from "./PaymentdetailKurir.vue?vue&type=script&lang=js"
import style0 from "./PaymentdetailKurir.vue?vue&type=style&index=0&id=4cd44d72&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports